import * as React from "react";

export declare interface Position {
    lat: number,
    lng: number,
}

export declare interface MarkerProps {
    id: number,
    title: string,
    lat: number,
    lng: number,
    icon: string,
    iconActive: string,
    popupContent?: React.ReactNode,
}

export declare interface onSelectMarker {
    (marker: MarkerProps) : void
}

export declare interface OnEvent {
    () : void
}

export declare interface MarkerNodeProps {
    marker: MarkerProps,
    isSelected: boolean,
    onClick: OnEvent,
    onCloseClick: OnEvent,
    children?: React.ReactNode;
}

export enum MapTypeId {
    SATELLITE = "satellite",
    ROADMAP = "roadmap",
    HYBRID = "hybrid",
    TERRAIN = "terrain",
}

export declare interface MapNodeProps {
    center: Position,
    markers: MarkerProps[],
    useClusters: boolean,
    offset: Position,
    initialZoom: number,
    onSelectMarker?: onSelectMarker,
    mapTypeId: MapTypeId,
    children?: React.ReactNode,
}



